module.exports = __webpack_public_path__ + "static/media/Expense Limits.ae0a9cae.svg";